"use client"

import { useAuth } from "@/hooks/use-auth"
import { LandingHero } from "./hero"
import { AuthenticatedHero } from "./authenticated-hero"

/**
 * Thin wrapper — renders AuthenticatedHero for logged-in users,
 * LandingHero for guests. Kept as its own file so hero.tsx and
 * authenticated-hero.tsx stay independent and pure.
 */
export function HeroSwitch() {
    const { isAuthenticated, isLoading } = useAuth()

    // While auth state is resolving show the public hero to avoid layout shift
    if (isLoading) return <LandingHero />

    return isAuthenticated ? <AuthenticatedHero /> : <LandingHero />
}
